import ReactDOM from "react-dom";
import {useState} from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import ax, {LOCATION_FORM, VERIFY_RECAPTCHA} from '%/axios';
import conso from '%/conso';
const LocationPage = () => {

  const [verified, setVerified] = useState(false);
  const [form, setForm] = useState({
    'Location-City': window.location.pathname.replace('/location/', ''),
    'Order-Number': '',
    'RMA-Number': '',
    'Message': '',
    'Company-Name': '',
    Email: '',
    'Phone-Number': '',
    'Full-Name': ''
  });

  const verifyToken = async (token) => {
    try {
      const res = await ax(VERIFY_RECAPTCHA, { token });
      if(res?.success) {
        setVerified(true);

      }
      return res;
    } catch (er) {
      conso.trace(er);
      // throw new Error();

    }
  }

  const handleChange = (e) => {
    const {name, value} = e.target;
    setForm(prev => ({...prev, [name]: value}));
  }

  const submitForm = async () => {
    try {

      if (!verified) return alert('Recaptcha is invalid.');
      const res = await ax(LOCATION_FORM, {
        data: form,
      });
      if (res) {
        window.location.href = '/contact-confirmation';
      }

    } catch (er) {
      conso.trace(er);
      alert('There was a problem submitting the form, please try again later.')

    }

  }
  return (
    <div class="contact-form-block-container">
      <div class="contact-form-block w-form">
        <h4 id="form-header" class="h4-heading-32px margin-bottom-16px">Fill in the Following Info</h4>
        <div id="form-subheader" class="paragraph-16" 
        style={{
          marginBottom: 16
        }}
        >We typically respond to all inquiries
          within 2 business days.
        </div>
        <form id="contact-us-form" class="form" 
        onSubmit={submitForm} aria-label="Form">
          <div class="form-row form-row--half">
            <div class="form-field contact-form-wrapper">
              <input 
              onChange={handleChange}
              value={form['Full Name']}
              name='Full-Name'
              placeholder="Full Name*" class="form-input contact-text-field w-input" type="text"
               id="contact_fullname" 
              />
            </div>
            <div class="form-field">
              <input 
              onChange={handleChange}
              value={form['Phone Number']}
              name='Phone-Number'
              required="" class="form-input contact-text-field w-input" placeholder="Phone Number*" type="text" id="contact_phone" 
              />
            </div>
            <div class="form-field">
              <input 
              onChange={handleChange}
              value={form['Email']}
              name='Email'
              class="form-input contact-text-field w-input" type="text" placeholder="Email Address*" />
              </div>
            <div class="form-field">
              <input 
              onChange={handleChange}
              value={form['Order-Number']}
              name='Order-Number'
              class="form-input contact-text-field w-input" 
              placeholder="Order Number" type="text" id="contact_orderno" 
              />
            </div>
            <div class="form-field">
              <input 
              onChange={handleChange}
              value={form['Company-Name']}
              name='Company-Name'
              required="" placeholder="Company Name*" class="form-input contact-text-field w-input" type="text" id="contact_companyname" 
              
              />
            </div>
            <div class="form-field">
              <input 
              onChange={handleChange}
              value={form['RMA-Number']}
              name='RMA-Number'
              required="" placeholder="RMA Number" class="form-input contact-text-field w-input" type="text" id="contact_rma"
              />
            </div>
          </div>
          <div class="form-field">
            <textarea placeholder="How can we help you today?" required="" 
            onChange={handleChange}
            value={form['Message']}
            name='Message'
            id="contact_question" rows="5" cols="50" class="form-input contact-field-text-area w-input"></textarea>
            </div>
          {/* <div class="g-recaptcha" data-sitekey="6LcjX0sbAAAAACp92-MNpx66FT4pbIWh-FTDmkkz"><div style="width: 304px; height: 78px;"><div><iframe title="reCAPTCHA" src="https://www.google.com/recaptcha/api2/anchor?ar=1&amp;k=6LcjX0sbAAAAACp92-MNpx66FT4pbIWh-FTDmkkz&amp;co=aHR0cHM6Ly9kYW5hc2FmZXR5c3VwcGx5LmNvbTo0NDM.&amp;hl=en&amp;v=Nh10qRQB5k2ucc5SCBLAQ4nA&amp;size=normal&amp;cb=i2hvgevxwu40" width="304" height="78" role="presentation" name="a-j6aw80ihkoxj" frameborder="0" scrolling="no" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox"></iframe></div><textarea id="g-recaptcha-response" name="g-recaptcha-response" class="g-recaptcha-response" style="width: 250px; height: 40px; border: 1px solid rgb(193, 193, 193); margin: 10px 25px; padding: 0px; resize: none; display: none;"></textarea></div><iframe style="display: none;"></iframe></div><br /> */}
          <ReCAPTCHA
            sitekey="6LfUY8clAAAAAEJBofevY7k63tePIyIea0cHFd6h"
            onChange={verifyToken}
          />

          <div class="form-actions" style={{marginTop: 16}}>
            <input class="login-submit-button w-button" type="submit" value="Send Message Now" />
          </div>

        </form>
      </div>
    </div>
  )
}

ReactDOM.render(
  <LocationPage />,
  document.getElementById('location-react')

)